import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import classNames from 'classnames';
import dayjs from 'dayjs';

import logo from '../../../assets/img/content/logo-2.png';
import { Card } from '../../helpers/Card';

import style from './style.module.css';

const TopSection = ({ onlineApproval }) => {
  const buyerLegalName = onlineApproval.get('buyerLegalName');
  const today = dayjs().format('dddd, MMMM DD, YYYY');

  return (
    <Card className={style.host}>
      <div className={style.codes}>
        <span className="field-label">Priority Codes</span>
        <ul className="list-unstyled">
          <li>&ldquo;A&rdquo; High Priority</li>
          <li>&ldquo;B&rdquo; Medium Priority</li>
          <li>&ldquo;C&rdquo; Low Priority</li>
        </ul>
      </div>
      <div className={style.title}>
        <h1 className={style.buyerName}>{buyerLegalName}</h1>
        <div className={style.approvalListLabel}>{onlineApproval.get('approvalListLabel')}</div>
        <div className={style.meta}>{today}</div>
        <div className={style.meta}>Sorted by: Sales</div>
      </div>
      <div className={style.rightPart}>
        <img alt="Harvey & Company" className={style.logo} src={logo} />
        <ul className={classNames(style.userList, 'list-unstyled')}>
          {onlineApproval.get('approvalListUsers', List()).map(user => {
            const title = user.get('title') ? `, ${user.get('title')}` : null;

            return (
              <li key={user.get('lastName')}>
                {user.get('firstName')} {user.get('lastName')}
                {title}
              </li>
            );
          })}
        </ul>
      </div>
    </Card>
  );
};

TopSection.propTypes = {
  onlineApproval: PropTypes.instanceOf(Map).isRequired,
};

export default memo(TopSection);
